import { render, staticRenderFns } from "./NoNav.vue?vue&type=template&id=c8edf91a"
import script from "./NoNav.vue?vue&type=script&lang=ts"
export * from "./NoNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8edf91a')) {
      api.createRecord('c8edf91a', component.options)
    } else {
      api.reload('c8edf91a', component.options)
    }
    module.hot.accept("./NoNav.vue?vue&type=template&id=c8edf91a", function () {
      api.rerender('c8edf91a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/NoNav.vue"
export default component.exports